export const SALE_TYPE = 'sale'
export const NAVIGATION_TYPE = 'navigation'
export const PRODUCT_TYPE = 'product'
export const PACKAGE_TYPE = 'package'
